import ModalElement from "../../Components/Modal";
import { ChangeEvent, useEffect, useState } from "react";
import Button from "../../Components/Button";
import { CardGuest } from "../../Components/CardGuest";
import { useGuests } from "../../Providers/Guests";
import { useUser } from "../../Providers/User";
import { Container, SearchBar, GuestList } from "./style";
import GuestsForm from "../../Components/FormRegisterGuests";
import Footer from "../../Components/Footer";
import { ListCardBox } from "../../Components/ListCardBox";
import { IGuest } from "../../Interfaces";

const Guests = () => {
  const { guests, addNewGuest } = useGuests();
  const { admAuth } = useUser();
  const [userInput, setUserInput] = useState<string>("");
  const [filteredGuests, setFilteredGuests] = useState<IGuest[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setUserInput(e.target.value);
    if (userInput.length > 0) {
      setFilteredGuests(guests.filter((elem) => elem.cpf.includes(userInput)));
    }
  };

  useEffect(() => {}, [guests]);

  const handleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <Container>
      <SearchBar>
        <input onChange={(e) => onChangeSearch(e)} placeholder="CPF" />
        <Button className="search">Procurar</Button>
      </SearchBar>
      <GuestList>
        <ListCardBox height="40vh">
          {userInput.length > 0
            ? filteredGuests?.map((el) => (
                <CardGuest
                  key={el.id}
                  infs={el}
                  deleteable={admAuth}
                  editable={admAuth}
                />
              ))
            : guests?.map((el) => (
                <CardGuest
                  key={el.id}
                  infs={el}
                  deleteable={admAuth}
                  editable={admAuth}
                />
              ))}
        </ListCardBox>
      </GuestList>
      <ModalElement
        isOpen={modalIsOpen}
        closeModal={handleModal}
        className="modal"
      >
        <GuestsForm handleForm={addNewGuest}></GuestsForm>
      </ModalElement>
      <div className="boxButton">
        <Button onClick={handleModal} className="addButton">
          Novo
        </Button>
      </div>
      <div className="footerPosition">
        <Footer />
      </div>
    </Container>
  );
};
export default Guests;
